// Matches --breakpoint-xs in tailwind.css, where the marquee animation starts
const MARQUEE_QUERY = '(min-width: 540px)';

export default function featuredIn () {

	const sections = document.querySelectorAll('section.featured-in:not([data-initialised])');

	if (! sections.length) return;

	sections.forEach(setup);

}



function setup (section) {

	const track = section.querySelector('.track');
	const strip = section.querySelector('.strip');
	const toggle = section.querySelector('.carousel-toggle');
	const prev = section.querySelector('.carousel-prev');
	const next = section.querySelector('.carousel-next');

	if (! track || ! strip || ! toggle || ! prev || ! next) return;

	section.setAttribute('data-initialised', '');

	const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	const marquee = window.matchMedia(MARQUEE_QUERY);
	let paused = reduced;

	const animation = () => track.getAnimations().find((anim) => anim.animationName === 'featured-in-scroll');

	const label = () => {
		toggle.classList.toggle('is-paused', paused);
		toggle.setAttribute('aria-label', paused ? 'Play featured logos' : 'Pause featured logos');
	};

	const render = () => {
		track.classList.toggle('is-paused', paused);
		track.classList.toggle('is-playing', ! paused);
		label();
	};

	const syncStrip = () => {
		if (marquee.matches) {
			strip.setAttribute('tabindex', '0');
		} else {
			strip.removeAttribute('tabindex');
		}
	};

	// Logo left edges within the first copy of the row. The animated track is
	// two copies, so anything past the halfway point is the duplicate set.
	const logoPositions = () => {
		const half = track.scrollWidth / 2;
		const trackLeft = track.getBoundingClientRect().left;
		return [...track.querySelectorAll('.logos:not([aria-hidden]) img')]
			.map((img) => img.getBoundingClientRect().left - trackLeft)
			.filter((pos) => pos >= -1 && pos < half - 1)
			.sort((a, b) => a - b)
		;
	};

	const move = (direction) => {
		const anim = animation();
		if (! anim) return;

		const duration = Number(anim.effect.getTiming().duration);
		const half = track.scrollWidth / 2;
		const positions = logoPositions();
		if (! duration || ! half || ! positions.length) return;

		paused = true;
		render();

		const time = anim.currentTime || 0;
		const loopPos = ((time % duration) / duration) * half;

		let target;
		if (direction > 0) {
			target = positions.find((pos) => pos > loopPos + 2);
			if (target == null) target = positions[0];
		} else {
			const previous = positions.filter((pos) => pos < loopPos - 2);
			target = previous.length ? previous[previous.length - 1] : positions[positions.length - 1];
		}

		const loopTime = (target / half) * duration;
		const iterations = Math.floor(time / duration);
		anim.currentTime = iterations * duration + loopTime;
	};

	render();
	syncStrip();

	toggle.addEventListener('click', () => {
		paused = ! paused;
		render();
	});

	prev.addEventListener('click', () => move(-1));
	next.addEventListener('click', () => move(1));

	section.addEventListener('keydown', (event) => {
		if (event.altKey || event.ctrlKey || event.metaKey) return;

		if (event.key === 'ArrowLeft') {
			event.preventDefault();
			move(-1);
		} else if (event.key === 'ArrowRight') {
			event.preventDefault();
			move(1);
		}
	});

	marquee.addEventListener('change', syncStrip);

}



/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on attribute change) without a page reload, so
	'DOMContentLoaded' only covers the first render - re-run init on every
	preview refresh too. ACF's block-preview JS may run in the iframe's own
	window or in the parent admin window depending on context, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=featured-in', featuredIn);
}
